import { PublicOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { getIsGeosearchEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { NavbarItem } from '@collaborate-health/uikit'

const GeosearchTab: React.FC = () => {
  const display = useSelector(getIsGeosearchEnabled)
  if (!display) {
    return null
  }

  return <NavbarItem name='Geosearch' href={Routes.geosearch} icon={<PublicOutlined />} />
}

export default GeosearchTab

